(() => {
let companyName = "Charlie, Breezeline Virtual Assistant",
lang = document.getElementsByTagName('html')[0].getAttribute('lang'),
width = screen.width,
isBuyflow = window.location.toString().includes("/checkout/"),
isMobile = width < 1024,
logo = "https://storage.googleapis.com/bzl-prod-ccaip-logo/BZL-logo.png";
isMobileChannel = "false";

// TRANSLATION SETTINGS
let translation = {
    "es": {
    ujet_greeting:"Hola, soy Charlie, tu asistente virtual de Breezeline. Estoy aquí para ayudarte con cualquier pregunta que puedas tener. Haz clic a continuación para comenzar.",
    ujet_message_queue: "",
    ujet_channel_chat: "",
    ujet_message_chat_start: "",
    ujet_common_support: "",
    ujet_chat_transfer_left: "",
    ujet_menu_title: "",
    ujet_common_yes: "Continuar",
    ujet_common_no: "Cancelar",
    ujet_chat_end: "Finalizar Chat",
    ujet_chat_input_placeholder: "Ingrese su mensaje aquí",
    ujet_start_title: `Selecciona tu idioma en el menú desplegable superior derecho o haz clic en <b>"Continuar"</b> para proceder en español. <br/><br/> Este chat es solo para información general, no debe utilizarse como asesoramiento legal y puede grabarse con fines de calidad. Al utilizar este chat, usted acepta la grabación y recopilación de sus datos según la política de privacidad de Breezeline: https://es.breezeline.com/policies-agreements`,
    ujet_chat_title_with_one_agent: "Chatear con {0}",
    ujet_pf_ah_no_deflect:
        "Lamentablemente, nos contactó fuera de horario. ¿Ha consultado las opciones de autoservicio ingresando a 'Mi cuenta' desde la web o la aplicación móvil My Breezeline? Para asistencia inmediata contáctenos al 888-536-9600",
    },
    "en": {
    ujet_greeting: "Hi, I'm Charlie, your Breezeline Virtual Assistant. I'm here to assist you with any questions you may have. Click below to get started.",
    ujet_message_queue: "",
    ujet_menu_title: "",
    ujet_channel_chat: "",
    ujet_message_chat_start: "",
    ujet_common_support: "",
    ujet_chat_transfer_left: "",
    ujet_common_yes: "Continue",
    ujet_common_no: "Cancel",
    ujet_start_title: `Please select your language from the top-right dropdown or click <b>"Continue"</b> to proceed in English. <br /><br /> This chat is for general information only, should not be relied upon for legal advice, and may be recorded for quality purposes. By using this chat, you agree to the recording and collection of your data per Breezeline's Privacy Policy: https://www.breezeline.com/policies-agreements`,
    ujet_chat_title_with_one_agent: "Chat with {0}",
        ujet_pf_ah_no_deflect:
            "Unfortunately, you have reached us after hours. Have you checked out our self-service options by logging into 'My Account' from the web or My Breezeline Mobile App? For immediate assistance please contact us at 888-536-9600",
    }
}

// LANGUAGE CHECK
lang === "es" ? lang = "es" : lang = "en";

if(isBuyflow) {
    let region = document.querySelector('#ccaiRegion').value;
    region = region === "" ? "Breezeline" : region;

    if(isMobile) {
        // BUYFLOW CHAT LAUNCHER (MOBILE)
        let chatLauncher = document.querySelector('.ccai-mobile-launcher');
        let chatIconClicked = () => ujet.start();
        chatLauncher.addEventListener('click', chatIconClicked, {once: true});

        var ujet = new UJET({
            logo,
            name: companyName,
            companyId: ccaiCompanyId,
            host: ccaiHost,
            lang: lang,
            translation: translation,
            tenant: ccaiTenant,
            launcher: false,
            customData: {
                userInformation: {
                    label: 'userInformation',
                    value: 'resident'
                },
                region: {
                    label: 'region',
                    value: region
                },
                isMobileChannel: {
                    label: 'isMobileChannel',
                    value: isMobileChannel
                },
                platform: {
                    label: 'platform',
                    value: 'web'
                }

            }
        });

        ujet.registerHook('loading', function() {
            chatLauncher.classList.add('spin');
        })

        ujet.on('created', function() {
            chatLauncher.classList.remove('spin');
            chatLauncher.addEventListener('click', function() {
                if(ujet.status === 'open' ) {
                    ujet.close()
                } else {
                    ujet.open()
                }
            });
        })

    } else {
        // BUYFLOW CHAT LAUNCHER (NOT MOBILE)
        let chatLauncher = document.querySelector('.ccai-launcher');
        let open = document.querySelector('.ccai-open');
        let close = document.querySelector('.ccai-close');
        let spinner = document.querySelector('.ccai-loader');
        let chatIconClicked = () => ujet.start();
        chatLauncher.addEventListener('click', chatIconClicked, {once: true});

        var ujet = new UJET({
            logo,
            name: companyName,
            companyId: ccaiCompanyId,
            host: ccaiHost,
            lang: lang,
            translation: translation,
            tenant: ccaiTenant,
            // WIDGET POSITION
            right: 'unset',
            bottom: '70px',
            launcher: false,
            customData: {
                userInformation: {
                    label: 'userInformation',
                    value: 'resident'
                },
                region: {
                    label: 'region',
                    value: region
                },
                isMobileChannel: {
                    label: 'isMobileChannel',
                    value: isMobileChannel
                },
                platform: {
                    label: 'platform',
                    value: 'web'
                }
            }
        });

        ujet.registerHook('loading', function() {
            open.style.opacity = 0;
            close.style.opacity = 0;
            spinner.style.opacity = 1;
            spinner.classList.add('spin');
        })

        ujet.on('close', function() {
            open.style.opacity = 1;
            close.style.opacity = 0;
        });
 
        ujet.on('created', function() {
            spinner.style.opacity = 0;
            close.style.opacity = 1;
            spinner.classList.remove('spin');
            chatLauncher.addEventListener('click', function() {
                if(ujet.status === 'open' ) {
                    close.style.opacity = 0;
                    open.style.opacity = 1;
                    ujet.close()
                } else {
                    close.style.opacity = 1;
                    open.style.opacity = 0;
                    ujet.open()
                }
            });
        })
    }

} else {
    // WEBSITE CHAT
    let region = document.querySelector('#ccaiRegion').value;
    region = region === "" ? "Breezeline" : region;

    var ujet = new UJET({
        logo,
        name: companyName,
        companyId: ccaiCompanyId,
        host: ccaiHost,
        tenant: ccaiTenant,
        lang: lang,
        translation: translation,
        customData: {
            userInformation: {
                label: 'userInformation',
                value: ccaiUserInformation
            },
            region: {
                label: 'region',
                value: region
            },
            isMobileChannel: {
                label: 'isMobileChannel',
                value: isMobileChannel
            },
            platform: {
                label: 'platform',
                value: 'web'
            }
        }
    });

    // ADD CLICK FUNCTIONALITY TO SUPPORT PAGE & CONTACT PAGE
    const webhost = window.origin;
    const currentUrl = window.location.href;
    const allowedUrlList = [
        `${webhost}/support`,
        `${webhost}/business/support`,
        `${webhost}/contact-us`,
    ];
    const isSupportPage = allowedUrlList.filter(url => url === currentUrl).length > 0;

    if(isSupportPage) {
        const chat = document.getElementById('chat');
        chat.style.cursor = "pointer";
        const chatIconClicked = () => ujet.start();
        chat.addEventListener('click', chatIconClicked, {once: true});

        ujet.registerHook('loading', function() {
            // LOADING ANIMATION
            textAnimation()
        })

        ujet.on('created', function() {

            setTimeout(() => {
                let loadingText = document.querySelector('.loading-text');
                let title = document.getElementById('chat').querySelector("div > h4");
                loadingText.remove();
                title.style.opacity = 1;
                title.style.height = "auto";
            }, 1000)

            chat.addEventListener('click', function() {
                if(ujet.status === 'open' ) {
                    ujet.close()
                } else {
                    ujet.open()
                }
            })
        });
    }
}

// GLOBAL FUNCTIONS
// AUTHENTICATE WEB SDK
ujet.on('created', function() {
    getAuthToken().then(token => {
        ujet.authenticate(token)
    })
});

// CLOSE INACTIVE CHAT
ujet.on('chat:status', function(status) {
    if (status === 'timeout') {
    ujet.close()
    }
});

// GET TOKEN
// ROUTE: /api/ccai/jwt
function getAuthToken() {
    return fetch(apiUrl + '/api/ccai/jwt', {
        method: "POST",
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    })
    .then(res => res.text())
    .then((token) => {
        return token
    })
    .catch(err => {
        console.error('ccaiWidget.js/Fetch Error: ', err)
    })
}

function textAnimation() {
    let title = document.getElementById('chat').querySelector("div > h4");
    let loadingText = document.createElement("div");
    loadingText.classList.add('loading-text');
    title.parentNode.insertBefore(loadingText, null);
    title.style.opacity = 0;
    title.style.height = 0;

    const childTextNode0 = document.createElement("span");
    const childTextNode1 = document.createElement("span");
    const childTextNode2 = document.createElement("span");
    const childTextNode3 = document.createElement("span");
    const childTextNode4 = document.createElement("span");
    const childTextNode5 = document.createElement("span");
    const childTextNode6 = document.createElement("span");
    const childTextNode7 = document.createElement("span");
    const childTextNode8 = document.createElement("span");
    const childTextNode9 = document.createElement("span");

    childTextNode0.textContent = "L";
    childTextNode1.textContent = "o";
    childTextNode2.textContent = "a";
    childTextNode3.textContent = "d";
    childTextNode4.textContent = "i";
    childTextNode5.textContent = "n";
    childTextNode6.textContent = "g";
    childTextNode7.textContent = ".";
    childTextNode8.textContent = ".";
    childTextNode9.textContent = ".";

    loadingText.appendChild(childTextNode0);
    loadingText.appendChild(childTextNode1);
    loadingText.appendChild(childTextNode2);
    loadingText.appendChild(childTextNode3);
    loadingText.appendChild(childTextNode4);
    loadingText.appendChild(childTextNode5);
    loadingText.appendChild(childTextNode6);
    loadingText.appendChild(childTextNode7);
    loadingText.appendChild(childTextNode8);
    loadingText.appendChild(childTextNode9);
}
})();
